import product1 from '@/assets/img/home-v5/pdct-01.jpg'
import product2 from '@/assets/img/home-v5/pdct-02.jpg'
import product3 from '@/assets/img/home-v5/pdct-03.jpg'
import product4 from '@/assets/img/home-v5/pdct-04.jpg'
import product5 from '@/assets/img/home-v5/pdct-05.jpg'
import product6 from '@/assets/img/home-v5/pdct-06.jpg'

import blog1 from '@/assets/img/home-v5/blog-01.jpg'
import blog2 from '@/assets/img/home-v5/blog-02.jpg'
import blog3 from '@/assets/img/home-v5/blog-03.jpg'
import blog4 from '@/assets/img/shortcode/blog/blog-10.jpg'
import blog5 from '@/assets/img/shortcode/blog/blog-11.jpg'
import blog6 from '@/assets/img/home-v6/blog.jpg'

export const feature = [
    {
        image:product1,
        name:'Luxury Sofa Set',
        product:'26 Products'
    },
    {
        image:product2,
        name:'Retro Style Vase',
        product:'40 Products'
    },
    {
        image:product3,
        name:'Table & Chair',
        product:'14 Products'
    },
    {
        image:product4,
        name:'Luxury Vase',
        product:'32 Products'
    },
    {
        image:product5,
        name:'Interior Element',
        product:'26 Products'
    },
    {
        image:product6,
        name:'Others',
        product:'66 Products'
    },
]

export const blogData = [
    {
        image:blog1,
        date:'13th March 2025',
        tag:'Vase',
        title:'Home Office Storage Ideas to Boost Productivity in 2023.'
    },
    {
        image:blog2,
        date:'5th May 2025',
        tag:'Interior',
        title:'Consectetur purus habitasse ut diam habitant varius.'
    },
    {
        image:blog3,
        date:'19th June 2025',
        tag:'Vase',
        title:'The Key Components of a Quality Sofa habitant vel tempor.'
    },
    {
        image:blog1,
        date:'13th March 2025',
        tag:'Vase',
        title:'Home Office Storage Ideas to Boost Productivity in 2023.'
    },
    {
        image:blog2,
        date:'5th May 2025',
        tag:'Interior',
        title:'Consectetur purus habitasse ut diam habitant varius.'
    },
    {
        image:blog3,
        date:'19th June 2025',
        tag:'Vase',
        title:'The Key Components of a Quality Sofa habitant vel tempor.'
    },
]

export const blogData2 = [
    {
        image:blog4,
        date:'13th March 2025',
        tag:'Home Decor',
        title:'The Art of Interior Design: Choosing the Perfect Furniture Online'
    },
    {
        image:blog5,
        date:'5th May 2025',
        tag:'Interior',
        title:'Transform Your Space: Top Furniture Trends for Modern Homes'
    },
    {
        image:blog6,
        date:'19th June 2025',
        tag:'Interior',
        title:'How to Choose the Perfect Furniture for Every Room in Your Home'
    },
]